import { BasePutRequest } from 'acscp/api/requests/core/basePutRequest';
import * as t from 'io-ts';
import { Authentication } from 'acscp/api/requests/core/baseRequest';

export class UpdateSubscribedPushNotificationChannelsRequest extends BasePutRequest<undefined> {
    constructor(pushNotificationId: string) {
        super(`push-notifications/update-subscribed-channels/${pushNotificationId}`, {}, null, t.undefined, Authentication.None);
    }
}
